import React from "react";

export const EqualIcon = ({ width = "24px", height = "24px", color = "black", className }) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 24 24" 
      fill="none" 
      className={className}
    >
      <path 
        d="M5.5 17C5.08334 17 4.72934 16.8543 4.438 16.563C4.14667 16.2717 4.00067 15.9173 4 15.5C3.99934 15.0827 4.14534 14.7287 4.438 14.438C4.73067 14.1473 5.08467 14.0013 5.5 14H18.5C18.9167 14 19.271 14.146 19.563 14.438C19.855 14.73 20.0007 15.084 20 15.5C19.9993 15.916 19.8537 16.2703 19.563 16.563C19.2723 16.8557 18.918 17.0013 18.5 17H5.5ZM5.5 10C5.08334 10 4.72934 9.85433 4.438 9.563C4.14667 9.27167 4.00067 8.91733 4 8.5C3.99934 8.08267 4.14534 7.72867 4.438 7.438C4.73067 7.14733 5.08467 7.00133 5.5 7H18.5C18.9167 7 19.271 7.146 19.563 7.438C19.855 7.73 20.0007 8.084 20 8.5C19.9993 8.916 19.8537 9.27033 19.563 9.563C19.2723 9.85567 18.918 10.0013 18.5 10H5.5Z" 
        fill={color}
      />
    </svg>
  );
};

